import React from "react";
import teams from "../../../data/Teams.json";
import TeamSection from "../../HomeThree/TeamSection";
import TeamLayout from "../TeamLayout";

export default function TeamTwo() {
  return (
    <TeamLayout
      pageTitle="Team"
      breadcrumbs={[
        { name: "Home", path: "/" },
        { name: "team" },
      ]}
    >
      <TeamSection
        teams={teams.teams}
        backgroundImg="none"
        className="text-none pb-240"
      />
    </TeamLayout>
  );
}
